import { PublishSubject } from '../../../lib/subjects.esm.js';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, key + "" , value);
  return value;
};
class ErrorApiForwarder {
  constructor() {
    __publicField(this, "subject", new PublishSubject());
  }
  post(error, context) {
    this.subject.next({ error, context });
  }
  error$() {
    return this.subject;
  }
}

export { ErrorApiForwarder };
//# sourceMappingURL=ErrorApiForwarder.esm.js.map
